<template>
  <div class="contact">
    <banner img="../assets/img/bgtop.jpg" title="联系我们 contact us"/>
    <div class="contact-section" v-loading="loading">
      <div class="contact-section-content">
        <div class="contact-section-content-center">
          <p class="abstract-title">邮箱 Email:{{ contact.email }}</p>
          <p class="abstract-content" style="margin: 20px 0;">联系电话 Phone:{{ contact.mobile }}</p>
          <p class="abstract-content" style="margin: 20px 0;">地址 Address:{{ contact.address }}</p>
          <p class="abstract-content" style="margin: 20px 0;">Facebook WhatsApp Tiktok:{{ contact.facebookPhone }}</p>
        </div>
        <p style="margin: 20px 0;">请使用微信扫描以下二维码添加联系人 <br>Please scan the following QR code with wechat to add a contact</p>
        <span>{{ contact.wxQrcode1Title }}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>{{ contact.wxQrcode2Title }}</span>
        <br>
        <img v-lazy="contact.wxQrcode1"/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

        <img v-lazy="contact.wxQrcode2"/>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      contact: {}
    };
  },
  mounted() {
    window.console.log("contact");
    this.$http
        .get("officialwebsiteContact/getActive")
        .then(response => {
          this.contact = response.data.result;
          this.loading = false;
        })
        .catch(function (error) {
          window.console.log(error);
        });
  }
};
</script>

<style lang="scss" scoped>
.contact {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;
  text-align: center;
  font-size: 30px;

  &-section {
    width: 100%;

    &-content {
      width: 100%;
      min-height: 400px;
      background-color: white;

      &-center {
        text-align: left;
        margin-left: 20%;
      }

      img {
        width: 220px;
        height: 220px;
      }
    }
  }
}
</style>
